import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import Input from '../../../common/form/input/input.jsx'
import {
  calculateElapsedSeconds,
  getTextAndSeconds,
  shouldStopAndCreateNewTimeCard
} from './timeClockUtil'

const TimeClock = ({ timer, timeSpent, type, stopAndCreateNewTimeCard }) => {
  const [timerSeconds, setTimerSeconds] = useState(timer.TimeInSeconds())

  useEffect(() => {
    const updateInterval = window.setInterval(
      () =>
        setTimerSeconds(
          calculateElapsedSeconds(timer.StartedOn(), new Date())
        ),
      1000
    )

    return () => window.clearInterval(updateInterval)
  }, [])

  if (shouldStopAndCreateNewTimeCard(timer, timerSeconds)) {
    stopAndCreateNewTimeCard()
  }

  const { timeTakenText, seconds } = getTextAndSeconds(timerSeconds, timeSpent)

  return type === 'timeCard' ? (
    <div className='timeclock'>
      <Input
        type='text'
        name='time'
        label='time.item.labelTimeInput'
        className='time'
        value={timeTakenText}
        size={10}
        maxLength={100}
        readOnly
      />
      <span className='timerseconds'>{seconds}</span>
    </div>
  ) : (
    <span className='timeclock spent'>
      {timeTakenText}:{seconds}
    </span>
  )
}

TimeClock.propTypes = {
  timer: PropTypes.object.isRequired,
  timeSpent: PropTypes.number,
  type: PropTypes.string.isRequired,
  stopAndCreateNewTimeCard: PropTypes.func.isRequired
}
TimeClock.defaultProps = {
  timeSpent: 0
}

export default TimeClock
